import { Point } from './coordinates';

export const rotatePoint = (point: Point, origin: Point, degrees: number): Point => {
  if (degrees === 0) return point;

  const radians = (degrees * Math.PI) / 180;
  const cos = Math.cos(radians);
  const sin = Math.sin(radians);
  const dx = point.x - origin.x;
  const dy = point.y - origin.y;

  return {
    x: origin.x + dx * cos - dy * sin,
    y: origin.y + dx * sin + dy * cos,
  };
};

export const rotatePoints = (points: number[], origin: Point, degrees: number): number[] =>
  points.map((point, index) => {
    const pointIndex = Math.floor(index / 2) * 2;
    const rotated = rotatePoint({ x: points[pointIndex], y: points[pointIndex + 1] }, origin, degrees);
    return index % 2 === 0 ? rotated.x : rotated.y;
  });
